import React, { useCallback, useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import * as Yup from "yup";
import ButtonSubmitFormikPermission from "../../../components/UI/Button/ButtonSubmitFormikPermission";
import FormAlert from "../../../components/UI/FormAlert/FormAlert";
import TextInputFormik from "../../../components/UI/TextInput/TextInputFormik";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import { AuthContext } from "../../../context/AuthContext";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
// import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import CheckBoxFormik from "../../../components/UI/Checkbox/CheckBoxFormik";
import OverlayInfoAdicional from "../../../components/UI/Overlays/OverlayInfoAdicional";

const validationSchema = Yup.object().shape({
  sqTipoInaptidao: Yup.string().default(),
  dsInaptidao: Yup.string().default(),
  fgAtivo: Yup.boolean(),
  fgInaptidao: Yup.string().default(),
  txInaptidao: Yup.string().default(),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "fgAtivo") {
    initialValues[key] = true;
  } else {
    initialValues[key] = "";
  }
});

const FormTipoInaptidao = ({ history, location }) => {
  const { state } = location;
  const { isAllowed } = useContext(AuthContext);
  const [dadosInfo, setDadosInfo] = useState({});
  // Formik
  const { request: requestForm, data: dataForm, errors: errorForm, isLoading } = useApiClient();

  const handleSubmit = useCallback(
    (values) => {
      if (values.sqTipoInaptidao) requestForm(apiRoutes.fiscalizacao.parametrizacao.alteraTipoInaptidao, values);
      else requestForm(apiRoutes.fiscalizacao.parametrizacao.incluiTipoInaptidao, values);
    },
    [requestForm],
  );

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const { setSubmitting, setErrors, isSubmitting, isValid, setFieldValue } = formik;

  useEffect(() => {
    if ((dataForm || errorForm) && isSubmitting && !isLoading) formik.setSubmitting(false);

    if (errorForm && isValid && !isLoading) formik.setErrors({ ...formik.errors, ...errorForm });
  }, [formik, setSubmitting, setErrors, isSubmitting, isValid, dataForm, errorForm, isLoading]);

  useEffect(() => {
    if (!dataForm && !errorForm) return;

    if (dataForm) {
      toast.success("Tipo de Inaptidão salvo com sucesso");
      history.push("/app/tipoinaptidao");
    }
  }, [dataForm, errorForm, history]);

  // Carregar item
  const {
    request: tipoInaptidaoRequest,
    data: tipoInaptidaoData,
    errors: tipoInaptidaoErrors,
    isLoading: tipoInaptidaoLoading,
  } = useApiClient();

  useEffect(() => {
    if (state && state.itemKey) {
      tipoInaptidaoRequest(apiRoutes.fiscalizacao.parametrizacao.consultaTipoInaptidao, { id: state.itemKey });
      delete state.itemKey;
    }
  }, [tipoInaptidaoRequest, state]);

  useEffect(() => {
    if ((!tipoInaptidaoData && !tipoInaptidaoErrors) || tipoInaptidaoLoading) return;

    if (!formik.values.sqTipoInaptidao && tipoInaptidaoData && tipoInaptidaoData.result.length) {
      const info = {
        codigo: tipoInaptidaoData?.result[0]?.sqTipoInaptidao,
        data: {
          nomeFormalInclusao: tipoInaptidaoData?.result[0]?.nomeFormalInclusao,
          nomeFormalAlteracao: tipoInaptidaoData?.result[0]?.nomeFormalAlteracao,
          documentoInclusao: tipoInaptidaoData?.result[0]?.usuarioInclusao,
          documentoAlteracao: tipoInaptidaoData?.result[0]?.usuarioAlteracao,
          dataInclusao: tipoInaptidaoData?.result[0]?.dataInclusao,
          dataAlteracao: tipoInaptidaoData?.result[0]?.dataAlteracao,
        },
      };

      formik.setValues({ ...tipoInaptidaoData.result[0] });
      setDadosInfo(info);

      if (tipoInaptidaoData.result[0].fgAtivo === "S" && tipoInaptidaoData && tipoInaptidaoData.result.length)
        setFieldValue("fgAtivo", true);
      else setFieldValue("fgAtivo", false);
    }

    if (tipoInaptidaoErrors) {
      toast.error(tipoInaptidaoErrors.message);
    }
  }, [formik, tipoInaptidaoData, tipoInaptidaoErrors, tipoInaptidaoLoading, setFieldValue]);

  return (
    <>
      <h1 className="h3 mb-4 text-gray-800">Tipo de Inaptidão</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">
                    {formik.values.sqTipoInaptidao ? "Alteração de Tipo de Inaptidão" : "Inclusão de Tipo de Inaptidão"}
                  </h6>
                </Col>
                <Col sm="1" className="text-right">
                  <OverlayInfoAdicional data={dadosInfo} />
                </Col>
              </Row>
            </div>
            <div className="card-body">
              <FormAlert
                formik={formik}
                data={dataForm}
                errors={errorForm}
                isLoading={isLoading || tipoInaptidaoLoading}
              />
              <Form noValidate onSubmit={formik.handleSubmit}>
                <fieldset
                  disabled={
                    formik.values.sqTipoInaptidao
                      ? !isAllowed(funcionalidades.tipoInaptidao.alterar)
                      : !isAllowed(funcionalidades.tipoInaptidao.inserir)
                  }
                >
                  <Row>
                    <Form.Group as={Col} sm={12} md={5}>
                      <Form.Label>Sigla</Form.Label>
                      <TextInputFormik formik={formik} field="txInaptidao" maxLength="10" />
                    </Form.Group>
                    <Form.Group as={Col} sm={12} md={5}>
                      <Form.Label>Nome</Form.Label>
                      <TextInputFormik formik={formik} field="dsInaptidao" maxLength="100" />
                    </Form.Group>
                    {/* <Form.Group as={Col} sm={6} md={6}>
                      <Form.Label>Situação</Form.Label>
                      <SelectInput
                        formik={formik}
                        field="fgAtivo"
                        options={[
                          { key: "", value: "", text: "" },
                          { value: "S", text: "Ativo" },
                          { value: "N", text: "Inativo" },
                        ]}
                      />
                    </Form.Group> */}
                    <Form.Group as={Col} sm={12} md={2}>
                      <CheckBoxFormik
                        style={{ paddingTop: 40 }}
                        inline="inline"
                        formik={formik}
                        field="fgAtivo"
                        label="Ativo"
                      />
                    </Form.Group>
                  </Row>
                </fieldset>
                <Row className="mt-2">
                  <Col>
                    {formik.isSubmitting ? (
                      <TextSpinner text="Registrando Tipo de Inaptidão..." />
                    ) : (
                      <ButtonSubmitFormikPermission
                        permission={
                          formik.values.sqTipoInaptidao
                            ? funcionalidades.tipoInaptidao.alterar
                            : funcionalidades.tipoInaptidao.inserir
                        }
                        disabled={formik.isSubmitting}
                        name="Salvar"
                      />
                    )}
                    {"    "}
                    {!formik.isSubmitting && !formik.values.sqTipoInaptidao && (
                      <Button variant="light" className="mr-3" onClick={formik.handleReset}>
                        Limpar
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="danger" onClick={() => history.goBack()}>
                        Cancelar
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormTipoInaptidao;
